<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "additional_form_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

@let pages = pages$ | async;
@let domains = domains$ | async;
@let selectedDeviceMode = selectedDeviceMode$ | async;

<sp-form-additional-settings-signal
    [isEduForm]="true"
    [isHasSuccessPageOption]="isHasSuccessPageOption()"
    [settings]="form().additionalFormSettings().value()"
    [pages]="pages ?? []"
    [siteDomains]="domains ?? []"
    [baseHref]="baseHref"
    [deviceMode]="selectedDeviceMode"
    (valueChangeEvent)="form().setAdditionalFormSettings($event)"
/>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
